<template>
  <div class="header-wrapper-completed-projects">
    <h1>{{ countryName }}</h1>
    <div>
      <div v-if="peopleImpacted && completed" class="header-subtitle">
        <span>{{ peopleImpacted.toLocaleString('en') }}</span>
        {{ completed ? 'People Impacted' : 'People to Help' }}
      </div>
      <div v-if="projectsCompleted && completed" class="header-subtitle">
        <span>{{ projectsCompleted.toLocaleString('en') }}</span>
        {{ completed ? 'Projects Completed' : 'Projects to Assign' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    countryName: String,
    peopleImpacted: Number,
    projectsCompleted: Number,
    completed: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.header-wrapper-completed-projects {
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  h1 {
    font-size: 50px;
    color: #404040;
  }
  .header-subtitle {
    span {
      color: #6b0101;
    }
    font-size: 30px;
  }
}
</style>
